var $a2a34aca197e3e2b$exports = {};
$a2a34aca197e3e2b$exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `A carregar...`,
    "noResults": `Sem resultados`,
    "valid": `(v\xe1lido)`
};


export {$a2a34aca197e3e2b$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
